function togglePageTransition() {
  const pageTransition =  document.querySelector('.m-page-transition');
  if (pageTransition) {
    pageTransition.classList.toggle('fade-in');
  }
}

function toggleEnableGiftWrap(event, state) {
  let wrapper = event.target.closest('#MinimogCartFooter');
  if (!wrapper) {
    wrapper = event.target.closest('.m-cart-addon__body.open');
  }

  if (wrapper) {
    let giftNote = wrapper.querySelector('textarea');
    let saveButton = wrapper.querySelector('[data-action-gift-wrap-save]');
    if (giftNote && saveButton && state) {
      giftNote.removeAttribute('disabled');
      saveButton.removeAttribute('disabled');
    }

    if (giftNote && saveButton && !state) {
      giftNote.disabled = true;
      saveButton.disabled = true;
      giftNote.value = '';
    }
  }
}

function updateCart(formData, fadeOut) {
  console.log('formData', formData);
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  }).then((response) => {if (fadeOut) {togglePageTransition();}console.log('response', response)}).catch((error) => {console.error("Error:", error);});

  // getCart().then(cartData => {
  //   console.log('cart-data',cartData);
  // });
}

async function getCart() {
  return fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
  }).then(response => response.json())
  .then(data => {
    return data;
  })
  .catch((error) => {
    console.error("Error-get:", error);
  });
}

function toggleGiftWrap(event) {
  const cartNoteWrapper = event.target.closest('[data-gift-wrap="true"]');
  const mainCartFooter = event.target.closest('#MinimogCartFooter');
  let fadeIn = false;

  if (cartNoteWrapper) {
    let checkboxGiftWrap = cartNoteWrapper.querySelector('.checkbox-toggle-gift-wrap');
    if(mainCartFooter) {
      togglePageTransition();
      fadeIn = true;
    }
    toggleEnableGiftWrap(event, checkboxGiftWrap.checked);
    if (checkboxGiftWrap.checked) {
      updateCart({attributes: {'Gift wrap':'yes'}},fadeIn);
    }
    if (!checkboxGiftWrap.checked) {
      updateCart({attributes: {'Gift wrap':'','Gift note': ''}},fadeIn);
    }
  }
}

function closeGiftWrap() {
  const mainGiftWrap = document.querySelector('#m-addons-gift-wrap');
  const overlay = document.querySelector('.m-cart__overlay');
  if (mainGiftWrap && overlay) {
    mainGiftWrap.classList.remove('open');
    overlay.classList.remove('open');
  }
}
 
function addGiftNote() {
  const giftNote = document.querySelector('textarea[name="gift-wrap"]');
  if (giftNote) {
    updateCart({attributes: {'Gift note': giftNote.value}});
    closeGiftWrap();
  }
}

function saveCancel(event) {
  if (event.target.classList.contains('cart-gift-wrap--close')) {
    closeGiftWrap();
  } else {
    addGiftNote()
  }
}

function mainCart(event) {
  event.preventDefault();
  const giftNote = document.querySelector('textarea[name="main-cart-gift-wrap"]');
  const cartNote = document.querySelector('textarea[name="main-cart-note"]');
  if (event.target.classList.contains('cancel')) {
    if (event.target.dataset.action == 'main-gift-wrap' && giftNote) {
      giftNote.value = giftNote.dataset.originalValue;
    }
    if (event.target.dataset.action == 'main-cart-note' && cartNote) {
      cartNote.value = cartNote.dataset.originalValue;
    }
  } else {
    if (giftNote && cartNote) {
      if (event.target.dataset.action == 'main-gift-wrap' && giftNote) {
        togglePageTransition();
        updateCart({attributes: {'Gift note': giftNote.value}}, true);
      }
      if(event.target.dataset.action == 'main-cart-note' && cartNote) {
        togglePageTransition();
        updateCart({ note: cartNote.value}, true);
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const giftWrapButtons = document.querySelectorAll('[data-action="gift-wrap"]');
  const customNotes = document.querySelectorAll('.custom-notes [data-action]');
  giftWrapButtons.forEach((button, index, array) => {
    button.addEventListener('click', (e)=> saveCancel(e));
  })

  customNotes.forEach((button, index, array) => {
    button.addEventListener('click', (e)=> mainCart(e));
  })
});